import { useAccessControlStore } from "../stores/accessControlStore";
import { useFreeHistoryStore } from "../stores/freeHistoryStore"

//caso o usuario seja grátis e estiver bloqueado e o conteúdo não estiver visto não carrega o conteúdo.
//Caso o conteúdo já esteja visto, carrega o conteúdo.

export const validateLoadContent = (contentSlug: string) => {
  const isBlocked = useFreeHistoryStore.getState().isBlocked;
  const viewedContent = useFreeHistoryStore.getState().viewedContent;
  const isFreeUser = useAccessControlStore.getState().isFreeUser;

  const content = viewedContent && viewedContent.find(item => item.slug === contentSlug) || null;

  if(isBlocked && isFreeUser) {
    if(!content) {
      return false;
    }

    if(!content.isValid) {
      return false;
    }
  }

  return true;
}